import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import api from '../utils/api';
import { API_URL } from '../components/config';
import HarvestingTopNav from '../components/HarvestingTopNav';
import { getViewAsMode } from '../utils/viewMode';
import './HarvestingBlogPage.css';

const HarvestingBlogListPage = () => {
  const location = useLocation();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const viewAsMode = getViewAsMode(location.search);
  const previewMode = Boolean(viewAsMode);
  const previewQuery = viewAsMode ? `?viewAs=${viewAsMode}` : '';

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = previewMode
          ? await axios.get(`${API_URL}/api/harvesting-posts/public`)
          : await api.get('/api/harvesting-posts/public');
        const payload = response.data;
        const normalizedPosts = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.posts)
            ? payload.posts
            : [];
        setPosts(normalizedPosts);
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching blog posts');
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [previewMode]);

  const stripHtml = (value) => {
    if (!value) return '';
    return value.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  };

  return (
    <div className="harvesting-blog-page">
      <HarvestingTopNav />

      <div className="blog-header">
        <Link to={`/harvesting${previewQuery}`} className="back-link">← Back to Harvesting Portal</Link>
        <h1>Harvesting Blog</h1>
        <p className="subtitle">Latest updates and community news</p>
      </div>

      {loading ? (
        <div className="loading">Loading posts...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : posts.length === 0 ? (
        <p className="no-posts">No posts available at this time.</p>
      ) : (
        <div className="blog-post-grid">
          {posts.map((post) => (
            <div key={post._id} className="blog-post-card">
              {post.imageUrl && (
                <div className="blog-post-image">
                  <img src={post.imageUrl} alt={post.title} />
                </div>
              )}
              <div className="post-date">
                {new Date(post.publishDate).toLocaleDateString('en-US', {
                  timeZone: 'America/Toronto',
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </div>
              <h3>{post.title}</h3>
              <p className="post-excerpt">
                {stripHtml(post.content).length > 160
                  ? stripHtml(post.content).substring(0, 160) + '...'
                  : stripHtml(post.content)}
              </p>
              <Link to={`/harvesting/blog/${post._id}${previewQuery}`} className="read-more-link">
                Read More →
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HarvestingBlogListPage;
